// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-settlement-software[data-v-34271cb6] {
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/ProjectSettlementSoftware/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,aAAA;ACAF","sourcesContent":["\n.project-settlement-software {\n  padding: 20px;\n}\n",".project-settlement-software {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
